import { createTheme } from '@mui/material/styles';

/**
 * Welti-Furrer Brand Colors
 */
export const brandColors = {
  primary: '#942642',
  primaryLight: '#b84e6a',
  primaryDark: '#6b1a2f',
  secondary: '#FFCC00',
  secondaryLight: '#FFD740',
  secondaryDark: '#C8A200',
  backgroundDefault: '#f5f5f5',
  backgroundPaper: '#ffffff',
  borderSubtle: 'rgba(0, 0, 0, 0.08)',
} as const;

/**
 * MUI Theme mit Welti-Furrer Branding und Design-Tokens.
 */
const theme = createTheme({
  palette: {
    primary: {
      main: brandColors.primary,
      light: brandColors.primaryLight,
      dark: brandColors.primaryDark,
      contrastText: '#ffffff',
    },
    secondary: {
      main: brandColors.secondary,
      light: brandColors.secondaryLight,
      dark: brandColors.secondaryDark,
      contrastText: '#000000',
    },
    background: {
      default: brandColors.backgroundDefault,
      paper: brandColors.backgroundPaper,
    },
  },
  shape: {
    borderRadius: 8,
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
    h4: {
      fontWeight: 600,
      fontSize: '1.75rem',
    },
    h6: {
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
        },
      },
      defaultProps: {
        disableElevation: true,
      },
    },
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          border: `1px solid ${brandColors.borderSubtle}`,
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-head': {
            fontWeight: 600,
            backgroundColor: brandColors.backgroundDefault,
          },
        },
      },
    },
    MuiDialog: {
      defaultProps: {
        PaperProps: {
          elevation: 8,
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 500,
        },
      },
    },
  },
});

export default theme;
